var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowRightTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.06,58.94 L40.06,16.94 C39.4689805,16.3892823 38.5479806,16.4055322 37.9767564,16.9767564 C37.4055322,17.5479806 37.3892823,18.4689805 37.94,19.06 L78.88,60 L37.94,100.94 C37.5386936,101.313941 37.3735016,101.877111 37.5092289,102.408578 C37.6449562,102.940045 38.0599554,103.355044 38.5914222,103.490771 C39.1228889,103.626498 39.6860588,103.461306 40.06,103.06 L82.06,61.06 C82.6449068,60.4743649 82.6449068,59.5256351 82.06,58.94 L82.06,58.94 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRightTwo);
export default __webpack_public_path__ + "static/media/icon-arrow-right-two.ea90cfd0.svg";
export { ForwardRef as ReactComponent };